import type { JSX } from 'react';
import { Link } from 'react-router';
import { Button, Card } from '@viniciomendesr/rayrovisk-design-system';
import { AuthLayout, AuthText } from './PasswordScreenParts';

/**
 * What a mistyped address used to be: a blank page, answered with 200.
 *
 * Blank is the part that costs a sale — a link shared with a character missing
 * looked like a product that had gone down. The 200 is the part that costs
 * rankings, because a page with no content and a success status is what Google
 * calls a soft 404. Static hosting cannot answer 404 here without breaking
 * `/biblioteca/:slug` on refresh, so the status stays 200 and the head asks
 * not to be indexed instead (`routeMeta.ts`).
 *
 * It uses the entry frame rather than its own, so the surface a person hits by
 * accident looks like the ones she hits on purpose.
 */
export function NotFoundScreen(): JSX.Element {
  return (
    <AuthLayout>
      <Card layer="functional" elevation="raised" padding="lg">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <h1 style={{ margin: 0, font: '400 24px/1.15 var(--rvk-font-expressive)' }}>
            Esse endereço não existe.
          </h1>
          {/* Names both readings without asking her to work out which is hers:
              she typed it wrong, or the link she received was already broken.
              Neither is her fault and neither needs explaining. */}
          <AuthText>
            Ou o link veio quebrado, ou faltou um caractere no caminho. Nada foi perdido: as
            duas portas do Roteirovisk continuam abertas aqui embaixo.
          </AuthText>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 9, alignItems: 'stretch' }}>
            <Link to="/">
              <Button variant="primary" fullWidth>
                Ver os dois produtos
              </Button>
            </Link>
            <Link to="/entrar">
              <Button variant="ghost" size="sm" fullWidth>
                Já comprei, quero entrar
              </Button>
            </Link>
          </div>
        </div>
      </Card>
    </AuthLayout>
  );
}
